(function(){
  /* Le fichier est appele par chaque section ORDO. On ne l'execute qu'une fois. */
  if(window.__ordoInit) return;
  window.__ordoInit = 1;

  var d=document, r=d.documentElement;
  r.classList.add('o-js');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function grain(){
    if(d.querySelector('.o-grain')) return;
    var g=d.createElement('div'); g.className='o-grain'; g.setAttribute('aria-hidden','true');
    d.body.appendChild(g);
  }

  function reveal(){
    var els = d.querySelectorAll('[data-o-reveal]:not(.is-in):not([data-o-rev])');
    if(!els.length) return;
    if(mqReduce.matches || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.setAttribute('data-o-rev','1'); e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        var el = en.target, i = 0;
        if(el.parentElement){ i = Array.prototype.indexOf.call(el.parentElement.children, el); }
        el.style.setProperty('--o-d', Math.min(i,5)*60 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin:'0px 0px -10% 0px', threshold:0.08 });
    els.forEach(function(e){ e.setAttribute('data-o-rev','1'); io.observe(e); });
  }

  var annonceCtl = [], visBound = false;
  function annonce(){
    d.querySelectorAll('[data-o-annonce]').forEach(function(root){
      if(root.dataset.oInit) return; root.dataset.oInit='1';
      var items = root.querySelectorAll('.o-annonce__i');
      if(items.length < 2) return;
      var i = 0, delay = parseInt(root.getAttribute('data-o-annonce'),10) || 5000, t = null;
      function step(){
        items[i].classList.remove('is-on');
        i = (i+1) % items.length;
        items[i].classList.add('is-on');
      }
      function start(){ if(!t) t = setInterval(step, delay); }
      function stop(){ if(t){ clearInterval(t); t = null; } }
      annonceCtl.push({ start:start, stop:stop });
      start();
    });
    if(!visBound){
      visBound = true;
      d.addEventListener('visibilitychange', function(){
        annonceCtl.forEach(function(c){ if(d.hidden){ c.stop(); } else { c.start(); } });
      });
    }
  }

  function stickyBar(){
    var bar = d.querySelector('[data-o-bar]');
    if(!bar || bar.dataset.oInit) return;
    bar.dataset.oInit = '1';
    var anchor = d.querySelector('[data-o-bar-anchor]') || d.querySelector('form[action*="/cart/add"]');
    if(!anchor || !('IntersectionObserver' in window)){ bar.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function(e){
      var passed = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', passed);
    }, { threshold:0 });
    io.observe(anchor);
  }

  function bundle(){
    d.querySelectorAll('[data-o-bundle]').forEach(function(root){
      if(root.dataset.oInit) return; root.dataset.oInit='1';
      var inputs = root.querySelectorAll('input[type="radio"][data-o-qty]');
      var qty    = root.querySelector('input[name="quantity"]');
      var slots  = root.querySelectorAll('[data-o-vslot]');
      var label  = d.querySelector('[data-o-bundle-label]');
      var price  = d.querySelector('[data-o-bundle-price]');
      var wrap   = d.querySelector('[data-o-bundle-swap]');

      /* Une couleur par brosse : on ouvre autant de selecteurs que de brosses. */
      function slotsFor(n){
        slots.forEach(function(s){
          var i = parseInt(s.getAttribute('data-o-vslot'),10) || 1;
          if(i <= n){ s.removeAttribute('hidden'); } else { s.setAttribute('hidden',''); }
        });
      }

      function sync(input, animate){
        if(!input) return;
        var n = parseInt(input.getAttribute('data-o-qty'),10) || 1;
        if(qty) qty.value = n;
        slotsFor(n);
        var l = input.getAttribute('data-o-label') || '';
        var p = input.getAttribute('data-o-price') || '';
        if(!label && !price) return;
        if(animate && wrap && !mqReduce.matches){
          wrap.setAttribute('data-swap','');
          setTimeout(function(){
            if(label) label.textContent = l;
            if(price) price.textContent = p;
            wrap.removeAttribute('data-swap');
          }, 140);
        } else {
          if(label) label.textContent = l;
          if(price) price.textContent = p;
        }
      }
      inputs.forEach(function(i){
        i.addEventListener('change', function(){ sync(i, true); });
        if(i.checked) sync(i, false);
      });

      /* La photo suit la couleur de la premiere brosse. Flou court pendant l'echange. */
      var sel = root.querySelector('select[name="id"]');
      var media = d.querySelector('[data-o-vmedia]');
      if(sel && media){
        sel.addEventListener('change', function(){
          var imgs = media.querySelectorAll('.o-vm__i');
          var target = media.querySelector('.o-vm__i[data-o-v="' + sel.value + '"]')
                    || media.querySelector('.o-vm__i[data-o-v="defaut"]');
          if(!target || target.classList.contains('is-on')) return;
          if(mqReduce.matches){
            imgs.forEach(function(i){ i.classList.remove('is-on'); });
            target.classList.add('is-on');
            return;
          }
          media.setAttribute('data-swap','');
          setTimeout(function(){
            imgs.forEach(function(i){ i.classList.remove('is-on'); });
            target.classList.add('is-on');
            media.removeAttribute('data-swap');
          }, 110);
        });
      }
    });
  }

  function marquee(){
    d.querySelectorAll('.o-mq__track').forEach(function(t){
      if(t.dataset.oDup) return;
      t.dataset.oDup = '1';
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  function arrows(){
    var svg = '<span class="o-btn__i" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M3 13L13 3M13 3H6M13 3v7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    d.querySelectorAll('.o-btn:not(.o-btn--block):not([data-o-noarrow])').forEach(function(b){
      if(b.querySelector('.o-btn__i')) return;
      b.insertAdjacentHTML('beforeend', svg);
    });
  }

  function init(){ grain(); reveal(); annonce(); stickyBar(); bundle(); marquee(); arrows(); }
  if(d.readyState === 'loading'){ d.addEventListener('DOMContentLoaded', init); } else { init(); }
  d.addEventListener('shopify:section:load', init);
})();
